import styled from "styled-components";
import skyImage from "../../../assets/images/png/sky_pattern.png";

export const BannerWrapper = styled.section`
  min-height: 100vh;
  height: 100vh;
  background-repeat: no-repeat;
  width: 100%;
  overflow: hidden;
  background-image: url(${skyImage});
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  @media (max-width: 991px) {
    min-height: 100%;
    height: 100%;
  }

  .buildings {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: var(--buildingsHeight);
    z-index: 100;
    overflow: hidden;

    @media (max-width: 991px) {
      transform: scale(1.1);
      height: 47vh;
      display: none;
    }

    @media (max-width: 767px) {
      transform: scale(1.2);
    }

    @media (max-width: 575px) {
      transform: scale(1.3);
      height: 40vh;
    }

    @media (max-width: 400px) {
      transform: scale(1.4);
    }
  }

  .holyLight {
    display: var(--holyLight);
    content: "";
    position: absolute;
    top: 50%;
    left: ${({ lang }) => (lang === "en" ? "53%" : "40%")};
    width: 50vw;
    height: 50vh;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.7) 0%,
      rgba(255, 255, 255, 0) 40%
    );
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 1000;
    @media (max-width: 991px) {
      display: none;
    }
    @media (max-height: 560px) {
      left: ${({ lang }) => (lang === "en" ? "60%" : "40%")};
    }
  }

  .person {
    position: absolute;
    transform: ${({ lang }) =>
      lang === "en"
        ? "scale(var(--personScale, 1))"
        : "scaleX(-1) scale(var(--personScale, 1))"};
    bottom: var(--personBottom, -2rem);
    left: var(--personLeft);
    right: ${({ lang }) => (lang === "ar" ? "31%" : "")};
    right: 25%;
    z-index: 101;

    @media (max-width: 1100px) {
      width: 25rem;
      bottom: -5rem;
      left: 23%;
    }

    @media (max-width: 991px) {
      display: none;
    }
    @media (max-height: 560px) {
       bottom: -6rem;
     }
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.6);
    z-index: 1;
  }

  > * {
    position: relative;
    /* z-index: 2; */
  }

  .banner-container {
    position: relative;
    height: 100%;
    padding-right: 0;
    padding-left: 0;
    @media (max-width: 991px) {
      margin-top: 4rem;
    }
  }

  .bannerContentWrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100vh;
    max-width: 1200px !important;
    gap: ${({ lang }) => (lang === "en" ? "3rem" : "0")};
    margin-right: auto;
    margin-left: auto;

    @media (max-width: 583px) {
      /* margin-left: 2rem; */
      /* width: 100%; */
    }
    @media (max-width: 991px) {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0vw;
    }

    .slider-wrapper {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 310px;
      height: 100%;
      margin-bottom: 3.5rem;
      z-index: 1;
      transform: scale(var(--sliderScale, 1));
      margin-top: var(--sliderTopMargin, 120px);

    }
    @media (max-width: 991px) {
      .slider-wrapper {
        width: 220px !important;
        margin-bottom: 0;
        margin-top: 1rem;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
      }
      .slider-wrapper .slider-image-wrapper {
        display: flex !important;
        height: fit-content !important;
        justify-content: center !important;
      }
      /* display: none !important;
      margin-right: 0; */
    }

    /* .caption-sub-heading {
      font-size: 2rem;
    } */

    .slider-image {
      width: 310px;
      height: var(--heightResize, 453px);
      object-fit: contain;
      @media (max-width: 991px) {
        width: 17rem;
        height: var(--heightResize);
      }
    }

    .banner-content {
      position: relative;
      margin-top: 3rem;
      margin-bottom: var(--bannerContentMarBot);
      width: var(--bannerContentWidth);
      z-index: 9999;
      width: 60%;
      padding-left: 15px;
      padding-right: 15px;
      /* margin-left: ${({ lang }) => (lang === "en" ? "50px" : "")}; */
      /* margin-right: ${({ lang }) => (lang === "ar" ? "50px" : "")}; */
      @media (max-width: 991px) {
        width: 100%;
        margin-bottom: 0;
      }
      @media (max-width: 575px) {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
    .caption-snd-heading {
      margin-bottom: 2rem;
    }

    .caption-heading-main,
    .caption-snd-heading {
      font-size: 4rem;
    }

    .cta-wrapper {
      display: flex;
      gap: 1rem;
      width: 70%;
      @media (max-width: 470px) {
        flex-direction: column;
        align-items: center;
        gap: 0.7rem;
        .signin-btn {
        }
      }
    }

    /* @media (max-width: 1199px) {
      gap: 10vw;
    } */
  }

  .text-styled {
    position: relative;
    right: 1rem;
    top: 0.625rem;
  }

  .down-btn {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 10;
    width: 5.625rem;
    bottom: -0.625rem;
  }

  @media (max-width: 991px) {
    /* .holyLight {
      display: none;
    } */

    .bannerContentWrapper {
      height: auto;
      min-height: auto;
      /* padding-top: 7.5rem;
      padding-bottom: 6.25rem; */

      .caption-sub-heading {
        font-size: 2.2rem;
      }

      .caption-snd-heading {
        margin-bottom: 1.25rem;
        font-size: 3.1rem;
      }

      .caption-heading-main {
        font-size: 3.1rem;
        line-height: 1.3;
      }

      .banner-content .bannerMan {
        width: 30rem;
        bottom: -0.625rem;
      }
    }

    .contactWrapper {
      button {
        gap: 0.5rem;
        height: 2.875rem;
        padding: 0px 0.625rem;

        span {
          font-size: 1rem;
        }
      }
    }
  }

  @media (max-width: 767px) {
    .bannerContentWrapper {
      .banner-content .bannerMan {
        width: 23rem;
      }

      .caption-sub-heading {
        font-size: 2rem;
      }

      .caption-snd-heading {
        font-size: 2.5rem;
      }

      .caption-heading-main {
        font-size: 2.5rem;
      }
    }
  }

  @media (max-width: 575px) {
    .bannerContentWrapper {
      padding-bottom: 0.625rem;

      .banner-content .bannerMan {
        width: 22rem;
        left: auto;
      }
    }
  }

  @media (max-width: 380px) {
    .bannerContentWrapper {
      .banner-content .bannerMan {
        width: 18rem;
        bottom: 0;
        right: -2rem;
      }
    }
  }
`;
